module.exports = __webpack_public_path__ + "img/banner_two.1a3b352b.png";